module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "timeslots"
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Timeslots")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('can', {
    attrs: {
      "action": "edit",
      "subject": "timeslots"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add timeslot",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.editTimeslot(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("On which days and at what times do our various radio shows commence?")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content timeslot-list-content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "row-key": "id",
      "max-height": "400",
      "width": "100%",
      "show-timeout": 150,
      "data": _vm.timeslots,
      "fit": true,
      "default-sort": {
        prop: 'title'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "Title",
      "class-name": 'client-link'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.editTimeslot(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.title))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.days,
      "label": "Days",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.times,
      "label": "Times",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "color",
      "label": "Color",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: (_vm.getCellStyle(scope.row)),
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom"
          },
          on: {
            "command": _vm.handleTimeslotAction
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                  Actions\n                  "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.editTimeslot,
              item: scope.row.id
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.deleteTimeslot,
              item: scope.row.id
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": this.isNewTimeslot ? 'New Timeslot' : 'Edit Timeslot',
      "visible": _vm.showEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditDialog = $event
      }
    }
  }, [(_vm.showEditDialog) ? _c('timeslot-edit', {
    attrs: {
      "weekdays": _vm.weekdays,
      "is-new": _vm.isNewTimeslot
    },
    on: {
      "cancel": function($event) {
        _vm.showEditDialog = false
      },
      "save": _vm.saveTimeslot
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-853f491c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/timeslots/TimeslotList.vue
// module id = 3361
// module chunks = 3